import React, {useEffect, useState} from 'react'
import ModalForm from '../../../../components/modalComponents/ModalForm';
import {useSubmitForm} from '../../../../hooks/useSubmitForm/useSubmitForm';
import {useManageGetRequest} from '../../../../hooks/useManageGetRequest/useManageGetRequest';
import {
    asignarItemToCampanaAPI,
    deleteItemFromCampanaAPI,
    getCampanaToEditAPI,
    getItemsByCampanaAPI
} from '../../../../consumers/backendApisUrls';
import InputText from '../../../../components/modalComponents/InputText';
import {usePropsInputs} from '../../../../hooks/useProps/usePropsInput';
import ModalEnabled from '../../../../components/modalComponents/ModalEnabled';
import {
    CustomCard,
} from "../../../../components/styledComponents/StyledComponents";
import styled from "styled-components";
import CustomCheckBoxForCards from '../../../../components/CustomCheckBoxForCards/CustomCheckBoxForCards';

const ListaDeItemsPorCampana = ({toggleModal, refreshPage, IdCampanaBeneficio}) => {
    const SECTION_NAME = "ListaDeItemsPorCampana";
    const KEYS = {
        IdCampanaBeneficio: "IdCampanaBeneficio",
        Nombre: "Nombre",
        EtiquetaDctoPlanillaMeses: "EtiquetaDctoPlanillaMeses",
        FechaInicio: "FechaInicio",
        FechaFin: "FechaFin",
        Lineamientos: "LineamientoFile",
    };
    const [formValues, setFormValues] = useState({});
    const [items, setItems] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [commonProps] = usePropsInputs(formValues, setFormValues, SECTION_NAME);
    const [submitForm] = useSubmitForm();
    const [executeGet] = useManageGetRequest();
    const [modalEnabled, setModalEnabled] = useState({
        isEnable: false,
        component: React.Fragment,
    });

    const handleSubmit = async (item) => {
        const IdBeneficioItem = item.IdBeneficioItem;
        let api;
        if (item.EsAsignado) api = deleteItemFromCampanaAPI();
        else api = asignarItemToCampanaAPI();
        setIsSubmitting(true);
        const payload = getPayload(IdBeneficioItem);
        try {
            await submitForm(Object.values(KEYS), api, payload, SECTION_NAME, getItemsByCampana);
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const getPayload = (IdBeneficioItem) => {
        const payload = {
            IdCampanaBeneficio: IdCampanaBeneficio,
            IdBeneficioItem: IdBeneficioItem,
        };
        return payload;
    };

    const init = async () => {
        const apiGetCampana = getCampanaToEditAPI(IdCampanaBeneficio);
        await executeGet(apiGetCampana, ({data}) => setFormValues(data));
    };

    const getItemsByCampana = async () => {
        const apiGetItemsByCampana = getItemsByCampanaAPI(IdCampanaBeneficio);
        await executeGet(apiGetItemsByCampana, ({data}) => setItems(data));
    };

    useEffect(() => {
        init();
        getItemsByCampana();
    }, []);

    return (
        <>
            <ModalEnabled
                modalEnabled={modalEnabled}
                setModalEnabled={setModalEnabled}
            />
            <ModalForm
                width="1250px"
                titulo="Lista de ítems por campaña"
                showModal={toggleModal}
                hasSaveButton={false}>
                <div className="row">
                    <div className="col-md-12">
                        <InputText
                            label="Campaña"
                            {...commonProps(KEYS.Nombre)}
                            isDisabled={true}
                            direction="column"
                        />
                    </div>
                    <div className="col-md-12 pb-3">
                        <CustomModalCardWrapper style={{margin: 0}}>
                            {items.map((item, i) => {
                                return (
                                    <Card EsActivo={true} key={`${item.IdBeneficioItem}-${i}`}>
                                        <div className="inner-content">
                                            <div className='checkbox-container'>
                                                <CustomCheckBoxForCards
                                                    checked={item.EsAsignado}
                                                    onChange={() => handleSubmit(item)}
                                                    size='xl'
                                                />
                                            </div>
                                            <CustomCardImage src={item.ImgSrc} loading="lazy"/>
                                        </div>
                                        <div className="card-text-descripcion">
                                            <p className="m-0">{item.Descripcion}</p>
                                        </div>
                                        <div className="card-text-monto">
                                            <p className="m-0">{item.Monto}</p>
                                        </div>
                                    </Card>

                                );
                            })}
                        </CustomModalCardWrapper>
                    </div>
                </div>
            </ModalForm>
        </>
    );
};

export default ListaDeItemsPorCampana;
const CustomModalCardWrapper = styled.div`
    display: grid;
    margin: 30px;
    grid-gap: 20px;
    grid-template-columns: 1fr 1fr 1fr 1fr;
`;

const Card = styled(CustomCard)`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 70% 20% 10%;
    width: 100%;
    height: 400px;

    border: 1px solid #d5d0d0;
    border-radius: 8px;
    position: relative;
    overflow: hidden;

    .checkbox-container {
        position: absolute;
        top: 10px;
        left: 10px;
        z-index: 1;
        cursor: pointer;
        background-color: white;
    }

    .inner-content {
        filter: ${({EsActivo}) => (EsActivo ? "" : "grayscale(100%)")};
        position: relative;
    }

    .card-text-descripcion {
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 600;
        font-size: 18px;
        text-align: center;
        height: 100%;
    }

    .card-text-monto {
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 600;
        font-size: 18px;
        height: 100%;
    }
`;

const CustomCardImage = styled.img`
    width: 100%;
    display: block;
    object-fit: cover;
    object-position: center right;
`;